import React, { useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import ViewTransactionInfo from '@components/layout/Modals/ViewTransactionInfo/ViewTransactionInfo.component'
import TransactionTable from '@components/pages/Billing/Transaction/TransactionTable.component'
import type { BillingOutletContext } from '@components/pages/Billing/Billing.component'
import type { TransactionEntry } from '@services/api/billing/transaction.api'

function BillingTransactionsPage(): React.ReactElement {
  const { hooks } = useOutletContext<BillingOutletContext>()
  const [selectedTransaction, setSelectedTransaction] =
    useState<TransactionEntry | null>(null)
  const [isViewModalOpen, setIsViewModalOpen] = useState(false)

  const handleView = (row: TransactionEntry): void => {
    setSelectedTransaction(row)
    setIsViewModalOpen(true)
  }

  const handleCloseModal = (): void => {
    setIsViewModalOpen(false)
    setSelectedTransaction(null)
  }

  return (
    <>
      <TransactionTable
        searchQuery={hooks.debouncedSearchQuery}
        filters={hooks.filters}
        onView={handleView}
        onCreateInvoice={hooks.handleCreateInvoice}
        suppressTableLoading={hooks.suppressTableLoading}
      />
      <ViewTransactionInfo
        isVisible={isViewModalOpen}
        closeModal={handleCloseModal}
        transaction={selectedTransaction}
      />
    </>
  )
}

export default BillingTransactionsPage
